import {
	crewMemberNoData,
	crewMemberNoneAvailable,
	EMPLOYMENT_TYPE_MAP,
} from 'pages/CrewMemberDetails/components/Info/const';

import { checkDateRelativeness, dateRelativness, formatDateDisplay, formatTime } from '../datetime';

const dateWithTime = (datetime) => `${formatDateDisplay(datetime)} ${formatTime(datetime)}`;

const labels = {
	[dateRelativness.now]: 'Available now',
	[dateRelativness.past]: 'Available since',
	[dateRelativness.future]: '',
	na: 'Unavailable next 48hrs or location unknown',
};

const getAvailabilityLabel = (availabilityDate) => {
	if (availabilityDate === null) return labels.na;
	const relationInTime = checkDateRelativeness(availabilityDate);
	switch (relationInTime) {
		case dateRelativness.now:
			return labels[relationInTime];
		default:
			return `${labels[relationInTime]} ${dateWithTime(availabilityDate)}`;
	}
};

export const constructDriverInfo = (data) => {
	const info = { ...data.getCrewMember };
	const {
		id,
		fullName,
		driverCard,
		lastWorkAssignment,
		currentLocation,
		nextAvailability,
		driverLicenseExpiresAt,
		medicalCheckExpiresAt,
		phone,
		currentEmploymentType,
		currentRun,
		currentJobs,
		hoursTracking,
		holdDowns,
	} = info;

	const homeLocation = info.currentHomeBase?.city?.name || crewMemberNoData;
	const currentLocationText = currentLocation?.station?.name || crewMemberNoData;
	const arrivalTimeToCurrentLocation = currentLocation?.fromTimestamp
		? `(since ${dateWithTime(currentLocation?.fromTimestamp)})`
		: null;
	const nextAvailableLabel = getAvailabilityLabel(nextAvailability);

	const driverLicenseInfo =
		driverLicenseExpiresAt !== null ? formatDateDisplay(driverLicenseExpiresAt) : '';
	const medicalCheckInfo =
		medicalCheckExpiresAt !== null ? formatDateDisplay(medicalCheckExpiresAt) : '';

	const lastAssignmentLabel =
		lastWorkAssignment !== undefined &&
		lastWorkAssignment !== null &&
		Object.hasOwn(lastWorkAssignment, 'activity')
			? `${lastWorkAssignment?.activity?.fromStation?.code} (${lastWorkAssignment?.activity?.fromStation?.name}) → ${lastWorkAssignment?.activity?.toStation?.code} (${lastWorkAssignment?.activity?.toStation?.name})`
			: crewMemberNoData;
	const run = currentRun || null;
	const jobs = currentJobs || null;

	return {
		id,
		fullName,
		driverCard,
		homeLocation,
		phone: phone !== null ? phone : crewMemberNoneAvailable,
		lastAssignmentLabel,
		currentLocation: currentLocationText,
		arrivalTimeToCurrentLocation,
		nextAvailableLabel,
		driverLicenseInfo,
		medicalCheckInfo,
		workingCycle: crewMemberNoData,
		employmentType: currentEmploymentType
			? EMPLOYMENT_TYPE_MAP[currentEmploymentType.employmentType]
			: crewMemberNoData,
		currentRun,
		run,
		jobs,
		hoursTracking,
		holdDowns,
	};
};
